import React from 'react';

import { RowButton } from '@eika/button';

import type { CrossBorderReceiver } from '../../../../generated-types';

import '../../Payment/SelectReceiver/ReceiverListItem.scss';

interface Props {
    crossBorderReceiver: CrossBorderReceiver;
    onClick: () => void;
}

const CrossBorderReceiverListItem: React.FC<Props> = ({ crossBorderReceiver, onClick }) => {
    return (
        <RowButton className="receiver-list-item__button" onClick={onClick}>
            <span className="receiver-list-item__list-item">
                <span className="receiver-list-item__list-item-name" data-testid="cross-boarder-receiver-name">
                    {crossBorderReceiver.name}
                </span>
                <span
                    className="receiver-list-item__list-item-number"
                    data-testid="cross-boarder-account-number-receiver"
                >
                    {crossBorderReceiver.account.number}
                </span>
            </span>
        </RowButton>
    );
};

export default CrossBorderReceiverListItem;
